// PublikaYA - Floating Chat Bubble Widget
// Non-invasive widget: injects bubble and panel on home, no dependency on frameworks
(function () {
  const STYLE_ID = 'pkya-chat-bubble-style-link';
  const BUBBLE_ID = 'pkya-chat-bubble';
  const PANEL_ID = 'pkya-chat-panel';
  const IFRAME_ID = 'pkya-chat-iframe';

  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  function ensureStylesheet() {
    if (document.getElementById(STYLE_ID)) return;
    const link = document.createElement('link');
    link.id = STYLE_ID;
    link.rel = 'stylesheet';
    link.href = '/css/chat-bubble.css';
    document.head.appendChild(link);
  }

  function createBubble() {
    if (document.getElementById(BUBBLE_ID)) return;
    const bubble = document.createElement('button');
    bubble.id = BUBBLE_ID;
    bubble.className = 'pkya-chat-bubble';
    bubble.setAttribute('aria-label', 'Abrir chat');
    bubble.replaceChildren();
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '26');
    svg.setAttribute('height', '26');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z');
    path.setAttribute('fill', 'white');
    path.setAttribute('fill-opacity', '0.92');
    svg.appendChild(path);
    const badge = document.createElement('span');
    badge.className = 'pkya-badge';
    badge.style.display = 'none';
    badge.textContent = '1';
    bubble.appendChild(svg);
    bubble.appendChild(badge);
    document.body.appendChild(bubble);
    return bubble;
  }

  function createPanel(options) {
    if (document.getElementById(PANEL_ID)) return;
    const panel = document.createElement('div');
    panel.id = PANEL_ID;
    panel.className = 'pkya-chat-panel';

    const header = document.createElement('div');
    header.className = 'pkya-chat-header';
    header.replaceChildren();
    const title = document.createElement('div');
    title.className = 'pkya-title';
    title.textContent = 'Asistente PublikaYA';
    const actions = document.createElement('div');
    actions.className = 'pkya-actions';
    const mkIconBtn = (id, titleText, svgNode) => {
      const b = document.createElement('button');
      b.className = 'pkya-icon-btn';
      b.id = id;
      b.type = 'button';
      b.title = titleText;
      b.appendChild(svgNode);
      return b;
    };
    const mkSvg = (w, h, viewBox) => {
      const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('width', String(w));
      s.setAttribute('height', String(h));
      s.setAttribute('viewBox', viewBox);
      s.setAttribute('fill', 'none');
      s.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      return s;
    };
    const minSvg = mkSvg(16, 16, '0 0 24 24');
    const minRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    minRect.setAttribute('x', '5');
    minRect.setAttribute('y', '11');
    minRect.setAttribute('width', '14');
    minRect.setAttribute('height', '2');
    minRect.setAttribute('fill', 'white');
    minSvg.appendChild(minRect);
    const closeSvg = mkSvg(16, 16, '0 0 24 24');
    const p1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p1.setAttribute('d', 'M18 6L6 18');
    p1.setAttribute('stroke', 'white');
    p1.setAttribute('stroke-width', '2');
    p1.setAttribute('stroke-linecap', 'round');
    const p2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p2.setAttribute('d', 'M6 6L18 18');
    p2.setAttribute('stroke', 'white');
    p2.setAttribute('stroke-width', '2');
    p2.setAttribute('stroke-linecap', 'round');
    closeSvg.appendChild(p1);
    closeSvg.appendChild(p2);
    actions.appendChild(mkIconBtn('pkya-minimize', 'Minimizar', minSvg));
    actions.appendChild(mkIconBtn('pkya-close', 'Cerrar', closeSvg));
    header.appendChild(title);
    header.appendChild(actions);

    const body = document.createElement('div');
    body.className = 'pkya-chat-body';

    if (options && options.iframeSrc) {
      const iframe = document.createElement('iframe');
      iframe.id = IFRAME_ID;
      iframe.className = 'pkya-chat-iframe';
      iframe.src = options.iframeSrc;
      iframe.referrerPolicy = 'no-referrer';
      iframe.loading = 'lazy';
      iframe.setAttribute('data-trusted', 'true');
      body.appendChild(iframe);
    } else {
      const empty = document.createElement('div');
      empty.className = 'pkya-chat-empty';
      const d = document.createElement('div');
      d.textContent = 'Chat Bot PublikaYa Pronto!';
      empty.appendChild(d);
      body.appendChild(empty);
    }

    panel.appendChild(header);
    panel.appendChild(body);
    document.body.appendChild(panel);

    // Actions
    panel.querySelector('#pkya-minimize').addEventListener('click', () => {
      panel.classList.remove('pkya-open');
    });
    panel.querySelector('#pkya-close').addEventListener('click', () => {
      panel.classList.remove('pkya-open');
    });

    return panel;
  }

  function togglePanel(open) {
    const panel = document.getElementById(PANEL_ID);
    if (!panel) return;
    if (open) panel.classList.add('pkya-open'); else panel.classList.remove('pkya-open');
  }

  ready(() => {
    ensureStylesheet();
    const bubble = createBubble();
    const panel = createPanel({
      // TODO: Si tienes un chatbot alojado (por ejemplo, Botpress o un widget propio), pega la URL abajo
      // iframeSrc: 'https://tu-chatbot-url/embedded',
    });

    if (bubble) {
      bubble.addEventListener('click', () => {
        const isOpen = document.getElementById(PANEL_ID)?.classList.contains('pkya-open');
        togglePanel(!isOpen);
      });
    }
  });
})();
